{
  "/": {
    "headline": "AI that works.",
    "subtitle": "Your ideas. Finished work.",
    "footer": "{{MODEL_TOTAL}} AI models. One workspace."
  },
  "/right-wing-ai": {
    "headline": "Arya.\nRight-wing AI.",
    "subtitle": "Conservative. Christian.",
    "footer": "gab.ai/right-wing-ai",
    "artwork": "raster"
  },
  "/api": {
    "headline": "{{MODEL_TOTAL}} models.\nOne API.",
    "subtitle": "Build with the models you love.",
    "footer": "OpenAI-compatible. Automatic routing."
  },
  "/mac": {
    "headline": "Big ideas.\nBeautifully done.",
    "subtitle": "Gab AI for Mac.",
    "footer": "Your files. Your browser. Your apps."
  },
  "/extension": {
    "headline": "AI alongside\nyour tabs.",
    "subtitle": "The Gab AI browser extension.",
    "footer": "For Chrome and Brave."
  },
  "/pricing": {
    "headline": "More possibilities.",
    "subtitle": "Find your plan with Gab AI.",
    "footer": "Start free. Unlock more with Plus."
  },
  "/features": {
    "headline": "One workspace.\nSo much more.",
    "subtitle": "Chat, create, and put AI to work.",
    "footer": "Models. Media. Files. Code."
  },
  "/download": {
    "headline": "Your AI.\nEverywhere.",
    "subtitle": "Take Gab AI with you.",
    "footer": "iPhone. iPad. Android. Mac. Web."
  },
  "/about": {
    "headline": "More time for\nwhat matters.",
    "subtitle": "Meet the people behind Gab AI.",
    "footer": "Built in Pennsylvania."
  },
  "/switch": {
    "headline": "Make yourself\nat home.",
    "subtitle": "Bring your conversations to Gab AI.",
    "footer": "Your chats. Your memories. Your next idea."
  },
  "/blog": {
    "headline": "Ideas worth\nexploring.",
    "subtitle": "News and insights from Gab AI.",
    "footer": "AI news. Practical guides. Fresh perspectives."
  },
  "/docs": {
    "headline": "A little guidance.\nA lot of possibility.",
    "subtitle": "Learn your way around Gab AI.",
    "footer": "Documentation and how-to guides."
  },
  "/learn": {
    "headline": "Learn AI.\nMake more.",
    "subtitle": "Practical lessons for everyday work.",
    "footer": "From your first prompt to a finished project."
  },
  "/use-cases": {
    "headline": "AI for\nwhat you do.",
    "subtitle": "Find a better way to do your work.",
    "footer": "Explore Gab AI use cases."
  },
  "/images": {
    "headline": "Picture the\npossibilities.",
    "subtitle": "Turn your ideas into images.",
    "footer": "Create art, photos, and illustrations."
  },
  "/videos": {
    "headline": "Ideas in motion.",
    "subtitle": "Create videos with Gab AI.",
    "footer": "From a prompt or a still image."
  },
  "/music": {
    "headline": "Find your sound.",
    "subtitle": "Create original music with Gab AI.",
    "footer": "From your idea to your next song."
  },
  "/voice": {
    "headline": "Just say it.",
    "subtitle": "Talk naturally with Gab AI.",
    "footer": "Real-time AI voice conversations."
  },
  "/models": {
    "headline": "More models.\nMore possibilities.",
    "subtitle": "Explore {{MODEL_TOTAL}} AI models in one place.",
    "footer": "One account. One workspace."
  },
  "/agents": {
    "headline": "Meet your\nAI assistants.",
    "subtitle": "Explore bots. Create your own.",
    "footer": "Give your AI a role and a purpose."
  },
  "/tools": {
    "headline": "A tool for\nyour next idea.",
    "subtitle": "Purpose-built AI tools in one place.",
    "footer": "Write. Create. Analyze. Build."
  },
  "/prompts": {
    "headline": "A better\nstarting point.",
    "subtitle": "Explore the Gab AI prompt library.",
    "footer": "Find a prompt. Make it yours."
  },
  "/explore": {
    "headline": "See what AI\ncan create.",
    "subtitle": "Explore the Gab AI community.",
    "footer": "Images. Videos. Music."
  },
  "/alternatives": {
    "headline": "Find your fit.",
    "subtitle": "Compare Gab AI with the alternatives.",
    "footer": "Models. Features. Value."
  },
  "/free-ai-chat": {
    "headline": "Start a\nconversation.",
    "subtitle": "Free AI chat with Gab AI.",
    "footer": "Explore ideas. Ask questions. Create."
  }
}
